"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var useComponentVisible_1 = __importDefault(require("../../../../app/components/hooks/useComponentVisible"));
var SocialDiscordValue = function () {
    var _a = (0, react_1.useState)(), value = _a[0], setValue = _a[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, useComponentVisible_1.default)(false), ref = _b.ref, isComponentVisible = _b.isComponentVisible, setIsComponentVisible = _b.setIsComponentVisible;
    (0, react_1.useEffect)(function () {
        var el = document.getElementById("social-discord-value");
        if (el) {
            var v = el.getAttribute('data-value');
            (v) && setValue(v);
        }
    }, []);
    function onItemClick() {
        setIsComponentVisible(true);
    }
    function handleOnClickValue() {
        if (value && navigator.clipboard)
            navigator.clipboard.writeText(value);
    }
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("img", { alt: t("img.social.alt.discord"), onClick: onItemClick, src: "/images/web/social/discord.svg" }),
        react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)("tooltip-text", isComponentVisible ? "tooltip-text-visibility " : "") },
            react_1.default.createElement("span", { onClick: handleOnClickValue }, value),
            react_1.default.createElement("img", { onClick: handleOnClickValue, style: { width: "16px", height: "16px" }, src: "/images/copy-svgrepo-com.svg" }))));
};
exports.default = SocialDiscordValue;
